<template>
  <div :class="payload.designator">
    <div class="pop_up_container" :style="{ left: modal_x, top: modal_y, width: modal_width + 'px' }">
      <draggable @x_coordinate="setModalX" @y_coordinate="setModalY">
        <div class="modal_title is-flex is-align-items-center is-justify-content-space-between">
          <p class="m-0">{{ title }}</p>
          <div class="is-flex is-align-items-center">
            <button
              v-if="payload.component_name"
              @click="copyModalNameToClipboard"
              class="button is-small is-ghost mr-2"
              title="Copy modal name to clipboard"
            >
              📋
            </button>
            <button
              @click="showPropsModal"
              class="button is-small is-ghost mr-2"
              title="Show modal props"
            >
              🔍
            </button>
            <img v-if="show_close_button" @click="closeModal" class="modal-close-btn btn" src="/white_x.svg" width="12px">
          </div>
        </div>
      </draggable>
      <component class="modal_form modal_content" dir="rtl" :is="payload.component_name" :updateTitle="updateTitle" :payload="payload" v-bind="payload.props"/>

      <!--
        Dirty-close confirm (UI_SPEC C4.2). `.pop_up_container`'s pop-up animation
        leaves a PERSISTENT transform, which makes it the containing block for
        `position: fixed` descendants — a full-viewport backdrop rendered in here
        would be trapped and mispositioned. So this is an absolutely positioned
        card confined within the modal box, not a viewport overlay.
      -->
      <div
        v-if="show_close_confirm"
        class="close-confirm-overlay"
        role="alertdialog"
        aria-modal="true"
        @keydown.esc.stop.prevent="cancelClose"
      >
        <div class="close-confirm-card">
          <p class="close-confirm-msg">לסגור? הטקסט שכתבת לא יישמר.</p>
          <div class="close-confirm-row">
            <button type="button" class="button is-danger" @click="confirmClose">סגירה</button>
            <button ref="closeConfirmCancel" type="button" class="button is-light-confirm" @click="cancelClose">ביטול</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import ApplicantProfilePdf from '@/components/ApplicantProfilePdf.vue'
import ApplicantCreateForm from '@/components/ApplicantCreateForm.vue'
import ApplicantForm from '@/components/admin/applicants/Form.vue'
import PositionForm from '@/components/admin/positions/Form.vue'
import CompanyForm from '@/components/admin/companies/Form.vue'
import ModalVettingForm from '@/components/ModalVettingForm.vue'
import ApplicantEducationsForm from '@/components/applicants/educations/Form.vue'
import ApplicantHistoryCompaniesForm from '@/components/applicants/history_companies/Form.vue'
import ApplicantLanguagesForm from '@/components/applicants/languages/Form.vue'
import ApplicantMeetingsForm from '@/components/applicants/meetings/Form.vue'
import ApplicantOffersForm from '@/components/applicants/offers/Form.vue'
import Files from '@/components/Files.vue'
import BreakStartModal from '@/components/BreakStartModal.vue'
import ModalDailySummary from '@/components/ModalDailySummary.vue'
import InternalNotes from '@/components/InternalNotes.vue'
import ServiceRecommendation from '@/components/ServiceRecommendation.vue'
import PositionLanguagesForm from '@/components/positions/languages/Form.vue'
import MessageForm from '@/components/MessageForm.vue'
import TextSearchResult from '@/components/TextSearchResult.vue'
import ExtraAttributesForm from '@/components/ExtraAttributesForm.vue'
import CVModalForm from '@/components/modals/CVModalForm.vue'
import CVModalSuperLiteForm from '@/components/modals/CVModalSuperLiteForm.vue'
import ChatbotConversationModal from '@/components/modals/ChatbotConversationModal.vue'
import FunnelDropOffModal from '@/components/modals/FunnelDropOffModal.vue'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import CvSendConfirm from '@/components/CvSendConfirm.vue'
import GhanaFlagForm from '@/components/GhanaFlagForm.vue'
import VettingForm from '@/components/VettingForm.vue'
import ModalTurnOnFlame from '@/components/ModalTurnOnFlame.vue'
import SearchModalDisplay from '@/components/SearchModalDisplay.vue'
import OfferStatusForm from '@/components/OfferStatusForm.vue'
import CompanyEducationsForm from '@/components/companies/educations/Form.vue'
import AdminMeetingForm from '@/components/admin/meetings/Form.vue'
import CompanyHistoryCompaniesForm from '@/components/companies/history_companies/Form.vue'
import AlertForm from '@/components/admin/alerts/Form.vue'
import StatForm from '@/components/admin/stats/Form.vue'
import FreezeApplicant from '@/components/FreezeApplicant.vue'
import PositionOffersForm from '@/components/positions/offers/Form.vue'
import AdminTagForm from '@/components/admin/AdminTagForm.vue'
import AdminSettingForm from '@/components/admin/AdminSettingForm.vue'
import LocationsForm from '@/components/LocationsForm.vue'
import CreatePositionStepOne from '@/components/CreatePositionStepOne.vue'
import CreatePositionStepTwo from '@/components/CreatePositionStepTwo.vue'
import CreatePositionStepThree from '@/components/CreatePositionStepThree.vue'
import ApplicantInfo from '@/components/modals/ApplicantInfo.vue'
import ModalApplicant from '@/components/modals/ModalApplicant.vue'
import AdminListInfo from '@/components/AdminListInfo.vue'
import ApplicantAlertsForm from '@/components/ApplicantAlertsForm.vue'
import OfferBoosterForm from '@/components/OfferBoosterForm.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import ModalWorkingHistory from '@/components/ModalWorkingHistory.vue'
import ModalAdminInProgress from '@/components/ModalAdminInProgress.vue'
import ModalAdminStats from '@/components/ModalAdminStats.vue'
import QuestionsForm from '@/components/QuestionsForm.vue'
import FeedAlertEditTiming from '@/components/FeedAlertEditTiming.vue'
import ContentFieldForm from '@/components/ContentFieldForm.vue'
import AttributeUpsertModal from '@/components/AttributeUpsertModal.vue'
import ModalWhatsapp from '@/components/ModalWhatsapp.vue'
import DeletePrompt from '@/components/DeletePrompt.vue'
import ModalTextarea from '@/components/ModalTextarea.vue'
import CreateCompanyStepOne from '@/components/CreateCompanyStepOne.vue'
import CreateCompanyStepTwo from '@/components/CreateCompanyStepTwo.vue'
import CreateCompanyStepThree from '@/components/CreateCompanyStepThree.vue'
import CreateCompanyStepFour from '@/components/CreateCompanyStepFour.vue'
import TextsForm from '@/components/TextsForm.vue'
import CompanyInfo from '@/components/CompanyInfo.vue'
import FeedAlertEdit from '@/components/FeedAlertEdit.vue'
import FeedAlertTimeLimit from '@/components/FeedAlertTimeLimit.vue'
import CompletenessIndicatorForm from '@/components/CompletenessIndicatorForm.vue'
import ApplicantSkillsForm from '@/components/ApplicantSkillsForm.vue'
import AdminOffersForm from '@/components/admin/offers/Form.vue'
import AdminOfferStatusesForm from '@/components/admin/AdminOfferStatusesForm.vue'
import AdminLanguagesForm from '@/components/admin/languages/Form.vue'
import AdminQuestionsForm from '@/components/admin/questions/Form.vue'
import AdminQuestionInfosForm from '@/components/admin/question_infos/Form.vue'
import AdminQuestionOptionsForm from '@/components/admin/question_options/Form.vue'
import TagsForm from '@/components/TagsForm'
import FilterMultiple from '@/components/FilterMultiple'
import FilterInputRange from '@/components/FilterInputRange'
import FilterMinMaxExperienceInputRange from '@/components/shared/molecules/FilterMinMaxExperienceInputRange'
import AlertWarningContent from '@/components/AlertWarningContent'
import Draggable from '@/components/Draggable'
import ModalDesignatedPositionFeedConformation from '@/components/ModalDesignatedPositionFeedConformation'
import CompanyInvitation from '@/components/CompanyInvitation'
import FeedAlertNoResponse from '@/components/FeedAlertNoResponse'
import CompanyAlertsForm from '@/components/CompanyAlertsForm'
import FeedModalReviewPosition from '@/components/FeedModalReviewPosition'
import PositionSkills from '@/components/positions/skills/Skills.vue'
import PositionTexts from '@/components/PositionTexts.vue'
import ModalPositionAdvanced from '@/components/ModalPositionAdvanced.vue'
import FeedAlertTimeExceed from '@/components/FeedAlertTimeExceed.vue'
import PositionEducations from '@/components/PositionEducations.vue'
import PositionQuestions from '@/components/PositionQuestions.vue'
import PositionLocations from '@/components/PositionLocations.vue'
import PositionLanguages from '@/components/PositionLanguages.vue'
import PositionRelatedOffers from '@/components/PositionRelatedOffers.vue'
import AdminEducationCoursesForm from '@/components/admin/education_courses/Form.vue'
import AdminEducationDegreesForm from '@/components/admin/education_degrees/Form.vue'
import AdminHistoryCompaniesForm from '@/components/admin/history_companies/Form.vue'
import AdminSkillsForm from '@/components/admin/skills/Form.vue'
import AdminListForm from '@/components/admin/AdminListForm.vue'
import AdminRequirmentForm from '@/components/admin/AdminRequirmentForm.vue'
import VestedConfirmationForm from '@/components/VestedConfirmationForm.vue'
import AdminEducationInstitutionsForm from '@/components/admin/education_institutions/Form.vue'
import AdminOwnerScheduleForm from '@/components/admin/owners_schedule/Form.vue'
import ResourceAlertsForm from '@/components/ResourceAlertsForm.vue'
import AdminBlogForm from '@/components/admin/blog/Form.vue'
import PositionStatusForm from '@/components/PositionStatusForm.vue'
import UploadFileForm from '@/components/UploadFileForm'
import FileEditor from '@/components/FileEditor'
import RelatedPositions from '@/components/RelatedPositions'
import AdminFeedDesignatorsForm from '@/components/admin/feed_designators/Form.vue'
import OutsourcePositionForm from '@/components/admin/outsource/Form.vue'
import DuplicatePosition from '@/components/DuplicatePosition.vue'
import CompanyEmployeesForm from '@/components/companies/employees/Form.vue'
import CompanyEmployeeForm from '@/components/companies/employees/CompanyEmployeeForm.vue'
import CVOfferStatusErrorForm from '@/components/CVOfferStatusErrorForm.vue'
import VestedForm from '@/components/VestedForm.vue'
import ModalCompanyWhatsApp from '@/components/ModalCompanyWhatsApp.vue'
import AdminHujiPositionForm from '@/components/admin/huji/Form.vue'
import CompanyOffers from '@/components/admin/CompanyOffers.vue'
import ConnectedPositionManager from '@/components/ConnectedPositionManager'
import RelatedResourceMessagePrompt from '@/components/RelatedResourceMessagePrompt'
import ResourceEffort from '@/components/ResourceEffort'
import StatResources from '@/components/StatResources'
import ModalEvaluate from '@/components/ModalEvaluate'
import ModalPosition from '@/components/ModalPosition'
import BreakStatusModal from '@/components/BreakStatusModal'
import FilesCompanyContracts from '@/components/FilesCompanyContracts'
import PresenceReportLogoutConfirmation from '@/components/PresenceReportLogoutConfirmation'
import AccountingCompanyForm from '@/components/AccountingCompanyForm'
import InactiveOutsourceHotPositions from '@/components/InactiveOutsourceHotPositions'
import CreatePositionPostForm from '@/components/CreatePositionPostForm'
import PositionApplicantsEmailSender from '@/components/PositionApplicantsEmailSender'
import HotPositionsForm from '@/components/HotPositionsForm'
import ModalMasterWhatsapp from '@/components/ModalMasterWhatsapp'
import CrudCertificationDateSeniority from '@/components/CrudCertificationDateSeniority'
import ChangeUserPasswordForm from '@/components/ChangeUserPasswordForm'
import ChangeUsernameForm from '@/components/ChangeUsernameForm'
import OfferWhatsAppModal from '@/components/OfferWhatsAppModal'
import KeyWordsUpsert from '@/components/KeyWordsUpsert'
import ModalWhatsappMessager from '@/components/ModalWhatsappMessager'
import DeveloperInterviewArticleForm from '@/components/admin/developer_interview_articles/Form.vue'
import DeveloperInterviewArticleCommentForm from '@/components/admin/developer_interview_article_comments/Form.vue'
import VettingRecipeForm from '@/components/admin/vetting_recipes/Form.vue'
import ModalOfferWhatsappTemplates from '@/components/ModalOfferWhatsappTemplates.vue'
import BugReportModal from '@/components/BugReportModal.vue'
import SystemSlowModal from '@/components/SystemSlowModal.vue'
import SendCvModeSelectionModal from '@/components/modals/SendCvModeSelectionModal.vue'
import PositionSearchForCvModal from '@/components/modals/PositionSearchForCvModal.vue'
import PositionSlotsModal from '@/components/modals/PositionSlotsModal.vue'
import SupplierLoginDetailsModal from '@/components/modals/SupplierLoginDetailsModal.vue'
import FilePreviewModal from '@/components/modals/FilePreviewModal.vue'
import CompanyEmployeesManager from '@/components/companies/employees/CompanyEmployeesManager.vue'
import OfferExposureModal from '@/components/modals/OfferExposureModal.vue'
import CvSendHistoryModal from '@/components/modals/CvSendHistoryModal.vue'
import OfferExposurePreparationModal from '@/components/modals/OfferExposurePreparationModal.vue'
import PropsDisplayModal from '@/components/PropsDisplayModal.vue'
import ModalOfferHandlingOptions from '@/components/ModalOfferHandlingOptions.vue'
import PhoneCallConfirmationModal from '@/components/PhoneCallConfirmationModal.vue'
import DesignatedPositionCompletionModal from '@/components/DesignatedPositionCompletionModal.vue'
import RejectAllOffersModal from '@/components/modals/RejectAllOffersModal.vue'
import FeedErrorReportModal from '@/components/modals/FeedErrorReportModal.vue'
import AiEvaluationModal from '@/components/modals/AiEvaluationModal.vue'
import PositionRecommendationModal from '@/components/modals/PositionRecommendationModal.vue'
import ConversationAnalysisModal from '@/components/ConversationAnalysisModal.vue'
import RecordingDetectedModal from '@/components/RecordingDetectedModal.vue'
import ChatbotProposalHandleModal from '@/components/modals/ChatbotProposalHandleModal.vue'
import ChatbotRejectReasonModal from '@/components/modals/ChatbotRejectReasonModal.vue'
import OfferRejectReasonModal from '@/components/modals/OfferRejectReasonModal.vue'
export default {
  props: ['payload'],
  name: 'modal',
  data () {
    return {
      show_close_button: this.payload.show_close_button == undefined ? true : this.payload.show_close_button,
      is_loading: false,
      title: this.payload.modal_title,
      modal_x: 0,
      modal_y: 'calc(50% - 35px)',
      show_close_confirm: false
    }
  },
  created () {
    this.initModalX()
  },
  watch: {
    payload () {
      this.initModalX()
    }
  },
  computed: {
    modal_width () {
      return this.payload.modal_width == undefined ? 750 : this.payload.modal_width
    },
    ...mapGetters('general', ['getCursorX']),
    ...mapGetters('modals', ['isDirtyGuarded'])
  },
  methods: {
    updateTitle (title) {
      console.log('hello')

      this.title = title
    },
    initModalX () {
      if (this.payload.is_center_modal) {
        this.modal_x = (window.innerWidth / 2) - (this.modal_width / 2) + 'px'
        return
      }
      if (this.payload.override_modal_x != undefined) {
        this.modal_x = this.payload.override_modal_x + 'px'
        return
      }
      this.modal_x = this.calculateModalXCoordinate() + 'px'
    },
    setModalX (modal_x) {
      this.modal_x = modal_x + 'px'
    },
    setModalY (modal_y) {
      this.modal_y = modal_y + 'px'
    },
    calculateModalXCoordinate () {
      let cursor_x = this.getCursorX
      let modal_width = this.modal_width
      let window_width = window.innerWidth
      let offset = 120
      if (cursor_x + (modal_width + offset) >= window_width) {
        return (cursor_x - this.modal_width - offset)
      }
      return (cursor_x + offset)
    },
    async copyModalNameToClipboard () {
      const componentName = this.payload.component_name
      if (componentName) {
        try {
          await navigator.clipboard.writeText(componentName)
          this.$utils.emit('show_toast', { text: `Copied: ${componentName}` })
        } catch (err) {
          // Fallback for older browsers
          const textArea = document.createElement('textarea')
          textArea.value = componentName
          document.body.appendChild(textArea)
          textArea.select()
          document.execCommand('copy')
          document.body.removeChild(textArea)
          this.$utils.emit('show_toast', { text: `Copied: ${componentName}` })
        }
      }
    },
    showPropsModal () {
      // Create a formatted display of all props passed to this modal
      const propsToShow = {
        component_name: this.payload.component_name,
        modal_title: this.payload.modal_title,
        designator: this.payload.designator,
        modal_width: this.payload.modal_width,
        show_close_button: this.payload.show_close_button,
        is_center_modal: this.payload.is_center_modal,
        override_modal_x: this.payload.override_modal_x,
        ...this.payload.props,
        // Include any other payload properties
        ...Object.keys(this.payload).reduce((acc, key) => {
          if (!['component_name', 'modal_title', 'designator', 'modal_width', 'show_close_button', 'is_center_modal', 'override_modal_x', 'props'].includes(key)) {
            acc[key] = this.payload[key]
          }
          return acc
        }, {})
      }

      // Format the props as a readable string
      const formattedProps = JSON.stringify(propsToShow, null, 2)

      // Create a new modal to display the props
      this.create({
        designator: 'modal-props-display',
        component_name: 'PropsDisplayModal',
        modal_title: `Props for ${this.payload.component_name || 'Modal'}`,
        modal_width: 800,
        is_center_modal: true,
        show_close_button: true,
        props: {
          propsContent: formattedProps
        }
      })
    },
    closeModal () {
      let payload = this.payload
      if (payload == undefined) {
        return
      }
      // A form (today: CVModalSuperLiteForm) registers `modals/dirtyGuard` while
      // its `manual_text` is non-empty. NOTE: Modal.vue has NO ESC handler and no
      // backdrop-close — the X is the only close path, so this is the single
      // interception point. Do not "fix" this by wiring events that never fire.
      if (this.isDirtyGuarded && this.isDirtyGuarded(payload.modal_id)) {
        this.show_close_confirm = true
        this.$nextTick(() => {
          const btn = this.$refs.closeConfirmCancel
          if (btn && btn.focus) btn.focus()
        })
        return
      }
      this.forceClose()
    },
    forceClose () {
      let payload = this.payload
      payload.is_fixed = false
      this.clearDirtyGuard(payload.modal_id)
      this.remove(payload)
    },
    confirmClose () {
      this.show_close_confirm = false
      this.forceClose()
    },
    cancelClose () {
      this.show_close_confirm = false
    },
    ...mapMutations('modals', ['create', 'remove', 'clearDirtyGuard'])
  },
  components: {
    ApplicantProfilePdf,
    FeedAlertEdit,
    FeedAlertEditTiming,
    FeedAlertNoResponse,
    ApplicantCreateForm,
    ApplicantForm,
    PositionForm,
    BreakStartModal,
    CompanyForm,
    ApplicantEducationsForm,
    CvSendConfirm,
    ApplicantHistoryCompaniesForm,
    ApplicantLanguagesForm,
    ApplicantMeetingsForm,
    ApplicantOffersForm,
    ModalConfirmation,
    ModalPosition,
    Files,
    ModalTextarea,
    ModalTurnOnFlame,
    TextSearchResult,
    InternalNotes,
    ServiceRecommendation,
    PositionLanguagesForm,
    MessageForm,
    ModalApplicant,
    ModalPositionAdvanced,
    ModalVettingForm,
    ExtraAttributesForm,
    CVModalForm,
    CVModalSuperLiteForm,
    ChatbotConversationModal,
    FunnelDropOffModal,
    ModalWhatsapp,
    GhanaFlagForm,
    FreezeApplicant,
    VettingForm,
    SearchModalDisplay,
    OfferStatusForm,
    CompanyEducationsForm,
    AdminMeetingForm,
    VestedConfirmationForm,
    CompanyHistoryCompaniesForm,
    ModalEvaluate,
    ModalWhatsappMessager,
    ModalMasterWhatsapp,
    AlertForm,
    StatForm,
    PositionOffersForm,
    LocationsForm,
    CreatePositionStepOne,
    CreatePositionStepTwo,
    CreatePositionStepThree,
    ModalDesignatedPositionFeedConformation,
    ApplicantInfo,
    AdminListInfo,
    ResetPassword,
    QuestionsForm,
    BreakStatusModal,
    FeedAlertTimeLimit,
    DeletePrompt,
    ModalWorkingHistory,
    FeedAlertTimeExceed,
    CreateCompanyStepOne,
    ModalAdminStats,
    CreateCompanyStepTwo,
    CreateCompanyStepThree,
    CreateCompanyStepFour,
    TextsForm,
    CompanyInfo,
    ModalCompanyWhatsApp,
    AlertWarningContent,
    FilesCompanyContracts,
    CompletenessIndicatorForm,
    ApplicantSkillsForm,
    ApplicantAlertsForm,
    OfferBoosterForm,
    AdminOffersForm,
    AdminLanguagesForm,
    CompanyInvitation,
    AdminRequirmentForm,
    FeedModalReviewPosition,
    AdminQuestionsForm,
    AdminQuestionInfosForm,
    AdminQuestionOptionsForm,
    ContentFieldForm,
    TagsForm,
    Draggable,
    PositionSkills,
    ModalAdminInProgress,
    AttributeUpsertModal,
    PositionTexts,
    PositionEducations,
    PositionQuestions,
    PositionLocations,
    PositionLanguages,
    PositionRelatedOffers,
    AdminEducationCoursesForm,
    AdminEducationDegreesForm,
    AdminHistoryCompaniesForm,
    AdminSkillsForm,
    AdminListForm,
    AdminEducationInstitutionsForm,
    AdminOwnerScheduleForm,
    ResourceAlertsForm,
    ModalDailySummary,
    AdminBlogForm,
    PositionStatusForm,
    UploadFileForm,
    FileEditor,
    RelatedPositions,
    FilterMultiple,
    FilterInputRange,
    FilterMinMaxExperienceInputRange,
    KeyWordsUpsert,
    AdminFeedDesignatorsForm,
    OutsourcePositionForm,
    DuplicatePosition,
    CompanyEmployeesForm,
    CompanyEmployeeForm,
    CVOfferStatusErrorForm,
    AdminTagForm,
    VestedForm,
    CompanyAlertsForm,
    AdminSettingForm,
    AdminHujiPositionForm,
    ConnectedPositionManager,
    RelatedResourceMessagePrompt,
    ResourceEffort,
    StatResources,
    PresenceReportLogoutConfirmation,
    AccountingCompanyForm,
    InactiveOutsourceHotPositions,
    CreatePositionPostForm,
    PositionApplicantsEmailSender,
    HotPositionsForm,
    ChangeUserPasswordForm,
    ChangeUsernameForm,
    OfferWhatsAppModal,
    AdminOfferStatusesForm,
    DeveloperInterviewArticleForm,
    DeveloperInterviewArticleCommentForm,
    CrudCertificationDateSeniority,
    VettingRecipeForm,
    ModalOfferWhatsappTemplates,
    BugReportModal,
    SystemSlowModal,
    SendCvModeSelectionModal,
    PositionSearchForCvModal,
    PositionSlotsModal,
    SupplierLoginDetailsModal,
    FilePreviewModal,
    CompanyOffers,
    CompanyEmployeesManager,
    OfferExposureModal,
    CvSendHistoryModal,
    OfferExposurePreparationModal,
    PropsDisplayModal,
    ModalOfferHandlingOptions,
    PhoneCallConfirmationModal,
    DesignatedPositionCompletionModal,
    RejectAllOffersModal,
    FeedErrorReportModal,
    AiEvaluationModal,
    PositionRecommendationModal,
    ConversationAnalysisModal,
    RecordingDetectedModal,
    ChatbotProposalHandleModal,
    ChatbotRejectReasonModal,
    OfferRejectReasonModal
  }
}
</script>
<style scoped>
.modal_content {
  text-align: right;
  overflow-y: auto;
  padding: 30px;
  max-height: 80vh;
}
.center_modal {
  position: absolute;
  left: calc(var(--left-column-width) * -1);
  padding-right: 60px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-background {
  position: fixed;
  z-index: 100000;
}
.pop_up_container {
  animation: 240ms cubic-bezier(0.25, 0.1, 0.25, 1) 0s 1 normal forwards running
    pop-up-animation;
  position: fixed;
  border-radius: 10px;
  z-index: 1000000;
  max-width: 95vw;
  background: white;
  -webkit-box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
}
@keyframes pop-up-animation {
  0% {
    opacity: 0;
  }
  25% {
    transform: translateY(-50%) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}
.modal_title {
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -ms-user-select: none;
  user-select: none;
  transition: 0.3s;
  cursor: move;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 10px 20px;
  font-size: 24px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: white;
  background-color: var(--color-header);
}
.modal_title:active{
  transition: 0.1s;
  color: black;
  background-color: #f2f2f2;
}
.modal_title p{
  pointer-events: none;
}
.close-confirm-overlay {
  position: absolute;
  inset: 0;
  background: rgba(44, 62, 80, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.close-confirm-card {
  width: 360px;
  max-width: 90%;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  direction: rtl;
  text-align: right;
  font-family: inherit;
}
.close-confirm-msg {
  font-size: 14px;
  line-height: 1.5;
  color: #2c3e50;
  margin: 0 0 16px;
}
.close-confirm-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.close-confirm-row .button {
  height: 34px;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
/* Red is correct here and only here: closing genuinely destroys the typed text
   and there is no undo. */
.close-confirm-row .button.is-danger {
  background: #ff3860;
  border: 1px solid #ff3860;
  color: #ffffff;
}
.close-confirm-row .button.is-light-confirm {
  background: #ecf0f1;
  border: 1px solid #bdc3c7;
  color: #2c3e50;
}
.close-confirm-row .button:focus-visible {
  outline: 2px solid #3273dc;
  outline-offset: 2px;
}
</style>
